import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getWebHookReceiverLogAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, getAccountWebHookReceiverLogAsync,updateSorting, setSortConfig, setPageSize } from './WebHookReceiverLogSlice';
import { Link } from 'react-router-dom'; 
import moment from 'moment';
import clsx from 'clsx';
import './WebHookReceiverLogStyle.css'
import { getValueFromResource } from '../../../common/timeLiveFunction';
const itemClass = 'ms-1 ms-lg-0';
const WebHookReceiverLogItem = (props: any) => {
    const dispatch = useAppDispatch();
    const { onhandleFilterOnClickEvent, offCanvasObject, t } = props;
    const { WebHookReceiverLogList, currentPage, pageSize, pageNo,startRec, totalItems, start, recordsFiltered, sortColumn,sortOrder,
        optionStatusText, optionStatusValue, optionWebHookEventTypeValue, optionWebHookEventTypeText, startDate, endDate, search, isReload, columnIndex, direction,isLoading
    } = useAppSelector((state) => state.webHookReceiverLog);

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onViewDetailClick = (AccountWebhookReceiverLogId: string) => {
        dispatch(getWebHookReceiverLogAsync(AccountWebhookReceiverLogId))
            .unwrap()
            .then((originalPromiseResult) => {
                onhandleFilterOnClickEvent(offCanvasObject);
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    // useEffect(() => {
    //     if ((sortColumn || sortOrder) && WebHookReceiverLogList.length > 0) {
    //         let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
    //         dispatch(getAccountWebHookReceiverLogAsync({ pageNo: 1, pageSize: pageSize, startRec: start, sortColumn: sortColumn, sortOrder: sortOrder, SearchParamsValues: SearchParamsValues, search: search }));
    //     }
    // }, [sortColumn, sortOrder]);

    // const handleSort = (columnIndex: number) => {
    //     dispatch(setSortConfig({ columnIndex, direction }));
    // };

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "startRec": 0,
            "pageSize": pageSize,
            "pageNo": 1
        }
        dispatch(updateSorting(objects));
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    


    return (
        <>
             {/* {isLoading && (
                <div className="spinner-overlay">
                    <div className="spinner"></div>
                </div>
            )}  */}
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle" >
                        <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={WebHookReceiverLogList.filter(item => item.StatusCode !== 200 && item.StatusCode !== 202).every((item) => item.isSelected === 0) ? false :
                                        (WebHookReceiverLogList.filter(item => item.StatusCode !== 200 && item.StatusCode !== 202).every((item) => item.isSelected === 1 ? true : false))
                                    }
                                    onChange={handleSelectAllChange}
                                />
                            </div>
                        </th>
                        
                                <th style={{width:'15%'}}>
                                    {/* {t('Date')} */}
                                    {getValueFromResource('Date',dispatch, t)}
                                  {sortColumn === 'ActionDate' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ActionDate") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ActionDate") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ActionDate") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ActionDate") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                                <th style={{width:'15%'}}>
                                    {/* {t('Date')} */}
                                    {getValueFromResource('Status',dispatch, t)}
                                  {sortColumn === 'ActionStatus' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "ActionStatus") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "ActionStatus") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "ActionStatus") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "ActionStatus") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}</th>
                        <th style={{ width: '20%' }}>
                            {/* {t('Status Code')} */}
                            {getValueFromResource('Status Code',dispatch, t)}
                            {sortColumn === 'StatusCode' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "StatusCode") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "StatusCode") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "StatusCode") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "StatusCode") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th style={{ width: '20%' }}>
                            {/* {t('Webhook Event Type')} */}
                            {getValueFromResource('Webhook Event Type',dispatch, t)}
                            {sortColumn === 'SystemWebhookEventTypeCaption' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemWebhookEventTypeCaption") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemWebhookEventTypeCaption") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "SystemWebhookEventTypeCaption") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "SystemWebhookEventTypeCaption") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th style={{ width: '20%' }}>
                            {/* {t('Coming From')} */}
                            {getValueFromResource('Coming From',dispatch, t)}

                            {sortColumn === 'RequestComingFrom' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "RequestComingFrom") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "RequestComingFrom") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "RequestComingFrom") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "RequestComingFrom") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th className='w-50px'></th>
                    </tr>
                </thead>
                <tbody>
                    {WebHookReceiverLogList.length === 0 && <tr><td colSpan={6}><p className='noDataFound mt-3'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}

                        </p></td></tr>}
                    {WebHookReceiverLogList.length > 0 && WebHookReceiverLogList.map((webHookReceiverLogDetail: any, i: any) => (
                        <tr key={i}>
                            {(webHookReceiverLogDetail.StatusCode == 200 || webHookReceiverLogDetail.StatusCode == 202) ?
                                <td></td>
                                :
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >

                                        <input
                                            type="checkbox"
                                            className="form-check-input widget-9-check"
                                            checked={webHookReceiverLogDetail.isSelected == 0 ? false : true}
                                            onChange={e => handleCheckboxChange(e, webHookReceiverLogDetail.AccountWebhookReceiverLogId)}
                                        />
                                    </div>
                                </td>
                            }

                            <td>
                                {/* <span className="d-block">
                                    {webHookReceiverLogDetail.ActionDate}
                                    
                                </span> */}
                                <span className="d-block">
                                                                        <i className="bi bi-calendar fs-5 me-2 align-middle" 
                                                                        //style={{ verticalAlign: 'middle' }}
                                                                        ></i>
                                                                        {moment.parseZone(webHookReceiverLogDetail.ActionDate).format('M/D/YYYY')}
                                                                    </span>
                            </td>


                            <td role="cell">
                                <span className="d-block">
                                    {(webHookReceiverLogDetail.ActionStatus === 'Fail' || webHookReceiverLogDetail.ActionStatus === 'fail')
                                        ? <span className="badge badge-light-danger fs-7">{webHookReceiverLogDetail.ActionStatus}</span>
                                        : (webHookReceiverLogDetail.ActionStatus === 'Success') ? <span className="badge badge-light-success fs-7">{webHookReceiverLogDetail.ActionStatus}</span>
                                            : <span className="badge badge-light-primary fs-7">{webHookReceiverLogDetail.ActionStatus}</span>
                                    }
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {webHookReceiverLogDetail.StatusCode}
                                </span>
                            </td>
                            <td>
                                <Link to={`../apiRecordLogs?webhookreceiverlogid=${webHookReceiverLogDetail.AccountWebhookReceiverLogId}`} >
                                    <span className='text-hover-primary d-block'
                                        style={{ verticalAlign: '0.2em', cursor: 'pointer' }}
                                    >
                                        {webHookReceiverLogDetail.SystemWebhookEventTypeCaption}
                                    </span>
                                </Link>
                            </td>
                            <td>
                                <span className="d-block">
                                    {webHookReceiverLogDetail.RequestComingFrom}
                                </span>
                            </td>                            
                            <td className='text-center' >
                                <div className={clsx('app-navbar-item', itemClass)}>
                                    <Dropdown
                                        style={{ marginLeft: 1 }}
                                        className={clsx('cursor-pointer symbol')}
                                        data-kt-menu-attach='parent'
                                        data-kt-menu-placement='bottom-end'
                                    >
                                        <Dropdown.Toggle
                                            variant="transparent"
                                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                            data-tooltip-id="tooltip-Description"
                                            data-tooltip-content=
                                            // {t("More")}
                                            {getValueFromResource('More',dispatch, t)}
                                            data-tooltip-place="bottom"
                                        >
                                            <i className="bi bi-three-dots fs-7 " ></i>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1   py-1 fs-7 w-auto' >
                                        <Dropdown.Item
                className="text-uppercase btn-icon-dark btn-text-dark"
                style={{ fontSize: 11 }} >
                <i className="bi bi-receipt fs-5 me-2"></i>
                <Link to={`../apiRecordLogs?webhookreceiverlogid=${webHookReceiverLogDetail.AccountWebhookReceiverLogId}`} >
                    <span style={{ verticalAlign: '0.2em' }}>{getValueFromResource('View API Records',dispatch, t)}</span>
                </Link>
            </Dropdown.Item>
{/*                                             <Dropdown.Item
                                                className="text-uppercase btn-icon-dark btn-text-dark"
                                                style={{ fontSize: 11 }} >
                                                <i className="bi bi-receipt fs-5 me-2"></i>
                                                <Link to={`../apiRecordLogs?webhookreceiverlogid=${webHookReceiverLogDetail.AccountWebhookReceiverLogId}`} >
                                                    <span style={{ verticalAlign: '0.2em' }}>
                                                        {getValueFromResource('View API Records',dispatch, t)}
                                                        </span>
                                                </Link>
                                            </Dropdown.Item> */}
                                            <Dropdown.Item
                                                className="text-uppercase btn-icon-dark btn-text-dark"
                                                style={{ fontSize: 11 }} >
                                                <i className="bi bi-receipt fs-5 me-2"></i>
                                                <Link to={`../webHookReceiverLogsAudit?WebhookReceiverLogId=${webHookReceiverLogDetail.AccountWebhookReceiverLogId}`} >
                                                    <span style={{ verticalAlign: '0.2em' }}>
                                                        {/* {t('View Webhook Receiver Log Audit')} */}
                                                        {getValueFromResource('View Webhook Receiver Log Audit',dispatch, t)}
                                                        </span>
                                                </Link>
                                            </Dropdown.Item>

                                            <Dropdown.Item
                                                id="kt_OffCanvas"
                                                className="text-uppercase btn-icon-dark btn-text-dark"
                                                style={{ fontSize: 11 }}
                                                onClick={() => { onViewDetailClick(webHookReceiverLogDetail.AccountWebhookReceiverLogId) }}
                                            >
                                                <i className="bi bi-receipt fs-5 me-2"></i>
                                                <span style={{ verticalAlign: '0.2em' }}>
                                                    {/* {t('View Detail')} */}
                                                    {getValueFromResource('View Detail',dispatch, t)}

                                                    </span>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </> 
    )
}

export default WebHookReceiverLogItem



{/* <tr>
{(webHookReceiverLogDetail.StatusCode == 200 || webHookReceiverLogDetail.StatusCode == 202) ?
    <td></td>
    :
    <td className="form-check form-check-custom form-check-solid form-check-sm">
        <input
            type="checkbox"
            className="form-check-input"
            checked={webHookReceiverLogDetail.isSelected == 0 ? false : true}
            onChange={e => handleCheckboxChange(e, webHookReceiverLogDetail.AccountWebhookReceiverLogId)}
        />
    </td>
}

<td>{webHookReceiverLogDetail.ActionDate}</td>
<td>{(webHookReceiverLogDetail.ActionStatus === 'Fail' || webHookReceiverLogDetail.ActionStatus === 'fail')
    ? <span className="badge badge-danger">{webHookReceiverLogDetail.ActionStatus}</span>
    : (webHookReceiverLogDetail.ActionStatus === 'Success') ? <span className="badge badge-success">{webHookReceiverLogDetail.ActionStatus}</span>
        : <span className="badge badge-primary">{webHookReceiverLogDetail.ActionStatus}</span>
}
</td>
<td>{webHookReceiverLogDetail.StatusCode}</td>
<td>
    <Link to={`../apiRecordLogs?webhookreceiverlogid=${webHookReceiverLogDetail.AccountWebhookReceiverLogId}`} >
        <span style={{ verticalAlign: '0.2em' }}>{webHookReceiverLogDetail.SystemWebhookEventTypeCaption}</span>
    </Link>
</td>
<td>{webHookReceiverLogDetail.RequestComingFrom}</td>

<td>
    <Dropdown style={{ marginLeft: 1 }}>
        <Dropdown.Toggle
            variant="secondary"
            className="btn btn-secondary btn-sm me-1 text-uppercase btn-icon-dark btn-text-dark"
            style={{ fontSize: 11 }}
        >
            Options
        </Dropdown.Toggle>
        <Dropdown.Menu>
            <Dropdown.Item
                className="text-uppercase btn-icon-dark btn-text-dark"
                style={{ fontSize: 11 }} >
                <i className="bi bi-receipt fs-5 me-2"></i>
                <Link to={`../apiRecordLogs?webhookreceiverlogid=${webHookReceiverLogDetail.AccountWebhookReceiverLogId}`} >
                    <span style={{ verticalAlign: '0.2em' }}>View API Records</span>
                </Link>
            </Dropdown.Item>
            <Dropdown.Item
                className="text-uppercase btn-icon-dark btn-text-dark"
                style={{ fontSize: 11 }} >
                <i className="bi bi-receipt fs-5 me-2"></i>
                <Link to={`../webHookReceiverLogsAudit?WebhookReceiverLogId=${webHookReceiverLogDetail.AccountWebhookReceiverLogId}`} >
                    <span style={{ verticalAlign: '0.2em' }}>View Webhook Receiver Log Audit</span>
                </Link>
            </Dropdown.Item>

            <Dropdown.Item
                className="text-uppercase btn-icon-dark btn-text-dark"
                style={{ fontSize: 11 }}
                onClick={() => { onViewDetailClick(webHookReceiverLogDetail.AccountWebhookReceiverLogId) }}
            >
                <i className="bi bi-receipt fs-5 me-2"></i>
                <span style={{ verticalAlign: '0.2em' }}>View Details</span>
            </Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>
</td>
</tr> */}